package com.imobly.imobly.api.dto.viacep

sealed class ResponseMessageViaCep